import { getFormattedExpirationDateFromToken } from './jwt'
import { getTokenFromStorage } from './localStorageUtils'

export const isTokenExpired = (token: string | null) => {
  const currentToken = token || getTokenFromStorage()
  if (!currentToken) {
    return true
  }
  const expDate = getFormattedExpirationDateFromToken(currentToken)?.valueOf()
  if (!expDate) {
    return true
  }
  return !(expDate.valueOf() > new Date().valueOf())
}

// TODO: write tests
